export const homepageCode = `const client = new OpenAI({
  baseURL: 'https://api.berget.ai/v1',
  apiKey: 'YOUR_API_KEY'
});

const res = await client.chat.completions.create({
  model: 'gemma-4-31B-it',
  messages: [{ role: 'user', content: 'Deploy app' }]
});`;
